/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
  Box,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from '@chakra-ui/react';
import useAxios from 'axios-hooks';
import { FeedbackData } from 'types';
import { InfoMaster, Loader, Paper, Rating, TextShowMore } from 'components';
// eslint-disable-next-line import/no-duplicates
import { format } from 'date-fns';
// eslint-disable-next-line import/no-duplicates
import { ru } from 'date-fns/locale';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DetailsMaster: React.FC<any> = ({
  tabIndex = 0,
  description,
  ...rest
}) => {
  const [{ data = [], loading, error }] = useAxios<FeedbackData>(
    {
      url: `/review/client/review/list`,
      params: {
        employeeId: rest.id,
      },
    },
    { manual: !rest.id },
  );

  return (
    <Paper w="100%" minH="50vh">
      <InfoMaster {...rest} />
      <Tabs
        defaultIndex={tabIndex}
        isFitted
        mt="44px"
        size="sm"
        colorScheme="green"
      >
        <TabList>
          <Tab _focus={{ boxShadow: 'none' }}>Информация</Tab>
          <Tab _focus={{ boxShadow: 'none' }}>Отзывы</Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            {description && (
              <Text
                color="black"
                textStyle="body1"
                mt="4"
                whiteSpace="pre-wrap"
                translate="no"
              >
                {description}
              </Text>
            )}{' '}
          </TabPanel>
          <TabPanel>
            <Loader loading={loading} error={error} />
            {data?.length ? (
              data.map((feedback, i) => {
                return feedback.rating ? (
                  <Box
                    key={String(i)}
                    _notFirst={{
                      pt: 4,
                    }}
                    _notLast={{
                      borderColor: 'grayBorder',
                      borderBottomWidth: '1px',
                      pb: 4,
                    }}
                  >
                    <Box display="flex" justifyContent="space-between" mb={1}>
                      <Text color="grayText" textStyle="body2">
                        {feedback.name}
                      </Text>
                      {feedback.date && (
                        <Text color="grayText" textStyle="body2">
                          {format(new Date(feedback.date), 'd MMMM yyyy', {
                            locale: ru,
                          })}
                        </Text>
                      )}
                    </Box>
                    <Rating value={feedback.rating} />
                    {feedback.feedback ? (
                      <TextShowMore text={feedback.feedback} />
                    ) : null}
                  </Box>
                ) : null;
              })
            ) : (
              <Text
                color="grayText"
                textStyle="body2"
                textAlign="center"
                pt={4}
              >
                Отзывов пока нет
              </Text>
            )}
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Paper>
  );
};
